import React from "react";

import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalFooter,
	ModalBody,
	ModalCloseButton,
	Flex,
} from "@chakra-ui/react";
import {
	IconShoppingCartLight as ShoppingCartIcon,
	Text3,
	Text5,
	ButtonPrimary,
	ButtonSecondary,
	TextField,
} from "@telefonica/mistica";
import { strings } from "../../../../localization";

interface SellersCodeModalProps {
	isOpen: boolean;
	value: string;
	onClose(): void;
	onConfirm(): void;
	onChange(value: string): void;
}

const SellersCodeModal: React.FC<SellersCodeModalProps> = ({ isOpen, onClose, onConfirm, onChange, value }) => {
	const texts = strings.components.withdrawResume.sellersCode.modal;

	return (
		<Modal
			isOpen={isOpen} onClose={onClose} isCentered
			size="2xl"
		>
			<ModalOverlay />
			<ModalContent
				sx={{
					background: "#ffff",
				}}
				maxW="635px"
				padding="32px 24px"
			>
				<ModalHeader p={0} marginBottom="24px">
					<ShoppingCartIcon size={64} color="#660099" />
				</ModalHeader>
				<ModalCloseButton color="#00000" />
				<ModalBody px={0}>
					<Flex flexDir="column" gap="24px">
						<Text5>
							{texts.title}
						</Text5>
						<Text3 light color="#696969">
							{texts.description}
						</Text3>
					</Flex>
					<Flex py="40px">
						<TextField
							fullWidth
							label="Código do vendedor"
							placeholder='Código do vendedor'
							name="sellersCode"
							onChangeValue={onChange}
							value={value}
							// error={hasError}
							// helperText={hasError ? "Tem algo errado com o código que você informou. Dê uma conferida" : ""}
						/>
					</Flex>
				</ModalBody>
				<ModalFooter justifyContent="flex-start" px={0} py={0}>
					<Flex gap={4}>
						<ButtonSecondary
							style={{
								minWidth: "180px",
							}}
							onPress={onClose}
						>
							{texts.btn_cancel}
						</ButtonSecondary>
						<ButtonPrimary
							style={{
								minWidth: "180px",
							}}
							onPress={() => onConfirm()}
						>
							{texts.btn_confirm}
						</ButtonPrimary>
					</Flex>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default SellersCodeModal;
